<template>
    <div style="height:100%;overflow-y: auto">
        <div class="bg-field">
            <div style="font-size:22px">{{data.name}}</div>
            <div class="vertical-center" style="margin-top: 10px">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                     class="svg-icon fa-svg-icon svg-fa-local_phone" width="20" height="20" viewBox="0 0 24 24">
                    <path d="M6.62 10.79a15.15 15.15 0 0 0 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path>
                </svg>
                <div @click="location.href='tel://'+data.phone" style="font-size: 15px;margin-left: 10px">
                    {{data.phone}}
                </div>
            </div>
        </div>
        <div class="text-field" ref="textField" v-html="data.detail"></div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast} from 'mint-ui';
    export default {
        data() {
            return {
                location: location,
                data: {
                    "name": "XXX",
                    "websiteUrl": "",
                    "phone": "***********",
                    "loc": "116.33412884875025,39.89264285417607",
                    "locName": "",
                    "locIntroduction": "",
                    "backImgUrl": "",
                    "detail": ""
                }
            }
        },
        methods: {},
        created(){
        },
        mounted() {
            console.log(2);
            api.getFormUrl(this, "yy/front/getBaseInfo", null, (res) => {
                utils.apply(this.data, res);
            }, (err) => {
                Toast({
                    message: err.rspDesc,
                    position: 'bottom',
                    duration: 5000
                });
                Indicator.close();
            });
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/common.css";

    .bg-field {
        background: rgb(6, 110, 230);
        color: white;
        padding: 20px 20px 50px 35px;
    }

    .svg-icon {
        fill: rgb(255, 255, 255);
        vertical-align: top;
    }

    .text-field {
        background: white;
        box-shadow: 0 0 3px rgba(0, 0, 0, .4);
        border-radius: 8px;
        margin: -30px 20px 20px 20px;
        padding: 20px;
    }
</style>